export function authHeader() {
    // return authorization header with jwt token
    const accessToken = localStorage.getItem('access_token');
    const idToken = localStorage.getItem('id_token');
    const guestId = localStorage.getItem('guest_id');
    const isFreemium = localStorage.getItem('session_mode') === 'freemium';
    if (!accessToken && !guestId && !isFreemium) {
        throw new Error('No access token found');
    }

    const headers = {};
    if (accessToken) headers.Authorization = 'Bearer ' + accessToken;
    if (idToken) headers.OpenId = 'Bearer ' + idToken;
    if (guestId && !isFreemium && !accessToken) headers.GuestId = guestId;
    return headers;
}



// WEBPACK FOOTER //
// ./src/helpers/auth-header.js